<template>
  <div class="imSession">
      <!-- <div class="imgMask" v-if="showImgMask">
        <img :src="imgMasksrc" alt="放大图" @click="magnify({data: imgMasksrc, status: 'success'})">
      </div> -->
      <ImagePreview :visible.sync="showImgMask" :imagePreviewUrl="imgMasksrc" @close="showImgMask = false" />
      <mask-evaluation v-if="showSatisfySettingFlag"></mask-evaluation>
      <im-top></im-top>
      <!--<div class="inner">-->
        <div class="sessionContent chat" @scroll="scorllTop">
          <ul class="chatUl">
             <!--{{satisfyMode === 2? messageList : "wososo"}}-->
            <div v-for="(item, index) in messageList" :key="index">
              <div class="createtime" v-if="item.type != 'EVENT' && !item.revoked">{{setTime(item.time)}}</div>
              <div class="createtime" style="margin-bottom:10px;color:#009688" v-if="item.type != 'EVENT' && item.revoked">{{setTime(item.time) + '  ' + '消息已被撤回'}}</div>
              <li class="chat-mine" v-if="item.sendFrom != visitorMd5Code && item.type != 'EVENT' && !item.revoked">

                <div class="chat-user"><img class="headerImg" :src="item.head"></div>
                <div class="wraper" >
                  <!--<span class="userNickName" v-if="item.type != 'EVENT'" v-text="item.userNickName"></span>-->
                  <span class="userNickName"  v-text="item.userNickName"></span>

                  <div class="chatContent" :class="{'nobg': item.type === 'IMAGE' || item.type === 'VIDEO'}">
                    <div v-if="item.type !== 'WORK_ORDER' " class="chat-text" :class="{'nobg': item.type === 'IMAGE' || item.type === 'VIDEO'}">
                      <div class="chat-text-Con" v-if="item.type === 'TEXT'" v-dompurify-html="replaceFace(item.data)"></div>
                      <!--<div class="chat-text-Con" v-if="item.type === 'EVENT' && item.data" v-text="item.data"></div>-->
                      <img v-else-if="item.type === 'IMAGE'" class="imgP" :src="item.data"
                          @click="magnify(item)">
                    </div>
                    <div v-if="item.type === 'WORK_ORDER'" class="chat-text1">
                      <div  ref="wraporder">
                        <div class='order'>
                          <work-order :msgId="item.msgId" :workOrderId="item.data" v-if="!item.toDo"></work-order>
                          <!--<div v-show="item.toDo">您填写的工单我们已经接收</div>-->
                          <!--<orderIm v-on:noAuth="handleNoAuth" :msgId="item.msgId" :workOrderId="item.data" ref="orderIm"></orderIm>-->
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </li>
              <li v-if="item.sendFrom==visitorMd5Code" class="chat-mine2">
                <div class="chatContent2" :class="{'nobg': item.type === 'IMAGE' || item.type === 'VIDEO'}">
                  <div class="chat-text2" :class="{'imgEmpty': (item.type === 'IMAGE' || item.type === 'VIDEO') && !item.data, 'nobg': item.type === 'IMAGE' || item.type === 'VIDEO'}">
                    <div class="chat-Con" v-if="item.type === 'TEXT'" v-dompurify-html="replaceFace(item.data, true)"></div>
                    <div v-else-if="item.type === 'IMAGE'" class="img-box">
                      <i v-if="item.status == 'loading'" class="el-icon-loading loading-icon"></i>
                      <img class="imgP" :src="item.data" @click="magnify(item)">
                    </div>
                    <!--  class="video-content-box" -->
                    <div v-else-if="item.type == 'VIDEO'">
                      <div class="more-dialog video-container">
                        <i v-if="item.status == 'loading'" class="el-icon-loading loading-icon"></i>
                        <i v-else-if="item.data" class="player-icon icon iconfont icon-bofang"></i>
                        <p class="masking-out" @click.stop="openVideo(item)"></p>
                        <img v-if="item.status == 'loading'" :src="item.data" width="100%" height="100%" alt="">
                        <img v-else-if="item.data" :src="item.data.split('?')[0] + '?x-oss-process=video/snapshot,t_1,f_jpg,m_fast,ar_auto'" width="100%" height="100%" alt="">
                        <!-- <div class="video-model">
                          <i v-if="item.status == 'loading'" class="el-icon-loading loading-icon"></i>
                          <img v-else src="../../assets/begin.png" alt="" class="video-play">
                        </div> -->
                      </div>
                    </div>
                  </div>
                </div>
                <div class="chat-user2"><img class="headerImg" :src="imgUrl+'user_pic@2x.png'"></div>
              </li>
            </div>
          </ul>
          <div class="emotions" v-if="emotionFlag">
            <div class="imgwraper">
              <div v-for="(imgItem,imgIndex) in Emotion" :key="imgIndex" class="emotion">
<!--                <img :src="imgItem.src" alt="表情包" @click="chooseEmotion(imgItem, imgIndex)">-->
                <span v-html="imgItem.text" @click="chooseEmotion(imgItem, imgIndex)" ></span>
              </div>
            </div>
            <div class="triangle"></div>
          </div>
        </div>
        <div class="sessionInput" v-show="endis">
          <div class="img_icon_box">
            <img :src="imgUrl+'hh_icon_bq.png'" alt="表情icon" class="img_icon_btn" @click="showEmotion" :class="{'hidden': isIE}">
            <img :src="imgUrl+'hh_icon_tp.png'" alt="表情icon" class="img_icon_btn">
            <img :src="imgUrl+'hh_icon_pj.png'" alt="表情icon" class="img_icon_btn" @click="showsatisfySetting">
            <span class="a-upload" :class="{'a-upload-left': isIE}">
            <!--   -->
              <input type="file" name="file" id="file" ref="imgfile" accept="image/gif,image/jpeg,image/jpg,image/png,image/svg, video/*" @change="sendImgMsg" multiple />
            </span>
          </div>
          <!-- <textarea  class="input_content" maxlength="140" style="height: 50px;width:97%;resize:none" v-model="msgValue" @keyup="msgChange(msgValue)" @keydown="sendMsg(msgValue,$event)"></textarea> -->
          <textarea  class="input_content" maxlength="140" style="height: 50px;width:97%;resize:none" v-model="msgValue" @keydown="sendMsg(msgValue,$event)"></textarea>
          <span  class="CtrEnt">按下Ctrl+Enter换行</span>
          <span class="sendMsg" @click='sendMsg2(msgValue,$event)' :style="{backgroundColor:boxBodyColor}">发送</span>
        </div>
        <div class="sessionInput endclass" v-show="endis==false">
          对话已结束，您可以点击 <a style="color:#319bf3;cursor:pointer;" @click="handleBack"> 开始新的会话</a>
        </div>
      <!--</div>-->
      <div v-if="isVideoShow" class="video-dialog">
        <div class="video-close" @click="closeVideo"><i class="el-icon-close"></i></div>
        <div class="video-content">
          <VideoModel :src="videoUrl" />
        </div>
      </div>
  </div>
</template>

<script>
import imTop from '../im/IMTop.vue'
import * as Constants from '../../common/Constants'
import {mapGetters} from 'vuex'
import maskEvaluation from '../maskEvaluation/maskEvaluation'
import VideoModel from '../../common/VideoModel'
import ImagePreview from '@/common/ImagePreview'
import workOrder from './workOrder'
import {Message} from 'element-ui'
import * as Urls from '../url.js'

Date.prototype.format = function(format){
    var o = {
      "M+" : this.getMonth()+1, //month
      "d+" : this.getDate(), //day
      "h+" : this.getHours(), //hour
      "m+" : this.getMinutes(), //minute
      "s+" : this.getSeconds(), //second
      "q+" : Math.floor((this.getMonth()+3)/3), //quarter
      "S" : this.getMilliseconds() //millisecond
    }

    if(/(y+)/i.test(format)) {
      format = format.replace(RegExp.$1, (this.getFullYear()+"").substr(4 - RegExp.$1.length));
    }

    for(var k in o) {
      if(new RegExp("("+ k +")").test(format)) {
        format = format.replace(RegExp.$1, RegExp.$1.length==1 ? o[k] : ("00"+ o[k]).substr((""+ o[k]).length));
      }
    }
    return format;
  }

export default {
  components:{
    imTop,
    maskEvaluation,
    workOrder,
    VideoModel,
    ImagePreview
  },
  name: 'ImSession',
  data () {
    return {
        // showSatisfySettingFlag:false,
        videoUrl: '',
        isVideoShow: false,
        isIE: false,
        showImgMask: false,
        imgMasksrc: '',
        boxBodyColor:'',
        msgValue:'',
        imgUrl: '/pc/static/assets/',
        //emoticons: '../../../static/Emotion'
        Emotion:[
          {src: '/pc/static/Emotion/weixiao.png', code: '[wx]',text:"🙂",reg:/\[wx\]/g,num:1},
          {src: '/pc/static/Emotion/daxiao.png', code: '[dx]',text:"😄",reg:/\[dx\]/g,num:2},
          {src: '/pc/static/Emotion/tiaopi.png', code: '[tp]',text:"😜",reg:/\[tp\]/g,num:3},
          {src: '/pc/static/Emotion/se.png', code: '[se]',text:"😍",reg:/\[se\]/g,num:4},
          {src: '/pc/static/Emotion/haixiu.png', code: '[hx]',text:"😳",reg:/\[hx\]/g,num:5},
          {src: '/pc/static/Emotion/piezui.png', code: '[pz]',text:"😖",reg:/\[pz\]/g,num:6},
          {src: '/pc/static/Emotion/fadai.png', code: '[fd]',text:"🙄",reg:/\[fd\]/g,num:7},
          {src: '/pc/static/Emotion/yiwen.png', code: '[yw]',text:"🤔",reg:/\[yw\]/g,num:8},
          {src: '/pc/static/Emotion/bizui.png', code: '[bz]',text:"🤐",reg:/\[bz\]/g,num:9},
          {src: '/pc/static/Emotion/nanguo.png', code: '[ng]',text:"☹️",reg:/\[ng\]/g,num:10},
          {src: '/pc/static/Emotion/liulei.png', code: '[ll]',text:"😢",reg:/\[ll\]/g,num:11},
          {src: '/pc/static/Emotion/daku.png', code: '[dk]',text:"😭",reg:/\[dk\]/g,num:12},
          {src: '/pc/static/Emotion/jingya.png', code: '[jy]',text:"😲",reg:/\[jy\]/g,num:13},
          {src: '/pc/static/Emotion/deyi.png', code: '[dy]',text:"😏",reg:/\[dy\]/g,num:14},
          {src: '/pc/static/Emotion/liuhan.png', code: '[lh]',text:"😓",reg:/\[lh\]/g,num:15},
          {src: '/pc/static/Emotion/ganga.png', code: '[gg]',text:"😒",reg:/\[gg\]/g,num:16},
          {src: '/pc/static/Emotion/zhiyi.png', code: '[zy]',text:"😐",reg:/\[zy\]/g,num:17},
          {src: '/pc/static/Emotion/shui.png', code: '[s]',text:"😴",reg:/\[s\]/g,num:18},
          {src: '/pc/static/Emotion/kun.png', code: '[k]',text:"😫",reg:/\[k\]/g,num:19},
          {src: '/pc/static/Emotion/jingkong.png', code: '[jk]',text:"😱",reg:/\[jk\]/g,num:20},
          {src: '/pc/static/Emotion/fanu.png', code: '[fn]',text:"😡",reg:/\[fn\]/g,num:21},
          {src: '/pc/static/Emotion/meigui.png', code: '[mg]',text:"🌹",reg:/\[mg\]/g,num:22},
          {src: '/pc/static/Emotion/zuicun.png', code: '[zc]',text:"💋",reg:/\[zc\]/g,num:23},
          {src: '/pc/static/Emotion/aixin.png', code: '[ax]',text:"❤️",reg:/\[ax\]/g,num:24},
        ],
        emotionFlag:false,
        basurl:Urls.baseurl,
        imEntranceMode:'',
    }
  },
  created() {
    if (!!window.ActiveXObject || "ActiveXObject" in window) {
      this.isIE = true;
    }
  },
  computed: {
      ...mapGetters({
        messageList: 'messageList',
        satisfyMode: 'satisfyMode',
        showSatisfySettingFlag:'showSatisfySettingFlag',
        messageContent: 'messageContent',
        endis:'endclass'
      }),
      visitorMd5Code: function () {
        return sessionStorage.md5
        //return "ae9773de040b64454b319389a64a3389"
      }
    },
  beforeRouteLeave (to, from, next) {
    var vm = this
    var obj = {
      id: vm.visitorMd5Code,
      time: vm.$store.state.im.userTime
    }
    var obj2 = {
      id: vm.visitorMd5Code,
      time: vm.$store.state.im.visitTime
    }
    var obj3 = {
      id: vm.visitorMd5Code,
      time: vm.$store.state.im.sessionTime
    }

    vm.$store.state.im.userTimeYes = false
    vm.$store.state.im.visitTimeYes = false
    // 结束会话
    clearInterval(vm.$store.state.im.userFun)
    clearInterval(vm.$store.state.im.visitorFun)

    clearInterval(vm.$store.state.im.visitorNoReplyTimer)
    clearInterval(vm.$store.state.im.sessionNoReplyTimer)
    clearInterval(vm.$store.state.im.userNoReplyTimer)

    clearTimeout(vm.$store.state.im.userNoReplyTimerOut)
    clearTimeout(vm.$store.state.im.visitorNoReplyTimerOut)

    localStorage.setItem('userTime',JSON.stringify(obj))
    localStorage.setItem('visitTime',JSON.stringify(obj2))
    localStorage.setItem('sessionTime',JSON.stringify(obj3))
    vm.$store.dispatch({
      type: 'getEnable',
      visitorMd5Code: vm.visitorMd5Code,
    })
    next();
  },
  mounted(){
    var vm=this;
    var obj = {
      id: vm.visitorMd5Code,
      time: localStorage.getItem('user')
    }
    var obj2 = {
      id: vm.visitorMd5Code,
      time: localStorage.getItem('visit')
    }
    var obj3 = {
      id: vm.visitorMd5Code,
      time: localStorage.getItem('session')
    }

    vm.$store.state.im.userTimeYes = false
    vm.$store.state.im.visitTimeYes = false

    localStorage.setItem('userTime',JSON.stringify(obj))
    localStorage.setItem('visitTime',JSON.stringify(obj2))
    localStorage.setItem('sessionTime',JSON.stringify(obj3))


    this.boxBodyColor = sessionStorage.getItem('boxBodyColor');
    this.renderPage();
    this.scrollToBottom();
    console.log('当前会话状态')
    console.log(vm.$store.state.im.endis)
    if(sessionStorage.getItem("addtime")){
      clearInterval(sessionStorage.getItem("addtime"))
    }
    var title1 = document.getElementsByTagName('title')[0];
    title1.innerHTML ='customer-service';
    vm.axios.get(vm.basurl + "/api/visitor/im/entrance?visitorMd5Code=" + vm.visitorMd5Code).then(function (response) {
        if(response.data.code == 1){
          vm.imEntranceMode = response.data.data.mode
        }
      }, function (response) {
        console.log(response)
      })
  },
  watch: {

      // '$route': 'getSatisfySetting'
    },
  methods: {
    // 打开视频
    openVideo(data) {
      if (!data.data) {
        return
      }
      if (data.status == 'loading') {
        return
      }
      this.videoUrl = data.data
      this.isVideoShow = true
    },
    // 关闭视频
    closeVideo() {
      this.videoUrl = ''
      this.isVideoShow = false
      this.$refs.videoModel.puse()
    },
    setTime(time){
          var go = new Date(time*1).format("yyyy-MM-dd hh:mm:ss")
          return go
    },
    handleBack(){
      var vm=this;
      vm.$store.state.im.endis=true;
       if(vm.imEntranceMode == 2){
          vm.$router.replace({path: 'imDirectory'})
        }else if(vm.imEntranceMode == 1){
          vm.$router.replace({path: 'imLineUp'})
        }
    },
    renderPage:function () {
      // 获取入口
      var vm = this;
      let path = this.$route.path;
      this.$store.state.im.messageList = [];
      clearInterval(this.$store.state.im.timer);


      // 获取公司的所有客服
      vm.$store.dispatch({
        type: 'initUserPool',
        visitorMd5Code: visitorMd5Code
      })

      // 创建socket

      this.$store.dispatch({
        type:'createSocket',
        router: vm.$router,
        path: path,
        visitorMd5Code: sessionStorage.md5
      })

      let seq = this.$store.state.im.messageList[0] ? this.$store.state.im.messageList[0].seq : null;
      let sessionId = this.$store.state.im.messageList[0]  ? this.$store.state.im.messageList[0].sessionId : null;
      let visitorMd5Code = sessionStorage.md5

      this.$store.dispatch({
        type:'getLastMessage',
        visitorMd5Code: sessionStorage.md5,
        router: vm.$router,
        offsetSeq: seq ,
        sessionId,
      }).then(() => {
        // 获取到聊天记录之后获取自动回复配置
        console.log("去获取自动聊天消息");
        vm.$store.dispatch({
          type:'getAutoReply',
          router: vm.$router,
          visitorMd5Code: sessionStorage.md5
        })

        vm.$store.dispatch({
          type: 'getHttp',
          visitorMd5Code: sessionStorage.md5
        })

      }).catch(() => {

      })
    },
    magnify (data) {
      if (!data.data) {
        return
      }
      if (data.status == 'loading') {
        return
      }
      this.imgMasksrc = data.data;
      this.showImgMask = !this.showImgMask;
    },
    scrollToBottom(){
        setTimeout(function () {
          var chat = document.getElementsByClassName('sessionContent')[0];
          chat.scrollTop = chat.scrollHeight;
        }, 100);
    },
    showEmotion () {
       this.emotionFlag  = !this.emotionFlag
    },
    chooseEmotion (item, index) {
      var vm = this;
      console.log(item);
      this.emotionFlag  = !this.emotionFlag
      //this.msgValue = item.code;
      //this.msgValue = this.replaceFace(item.code);
      // this.$store.dispatch({
      //   type: 'sendMessage',
      //   content: this.msgValue,
      //   contentType: Constants.TEXT_TYPE,
      //   visitorMd5Code: sessionStorage.md5
      // })

      // vm.msgValue = this.msgValue+item.code;
      vm.msgValue = this.msgValue+item.text;
    },
    //替换表情代码
    replaceFace: function (con, isRelace) {
      // 如果是用户自己发的先把关键字符转义后再去匹配表情头像
      // console.log('con before replace',con.replace(/</g, '&lt;').replace(/>/g, '&gt;'))
      if (isRelace) {
        con = con.replace(/</g, '&lt;').replace(/>/g, '&gt;')
      }
      var _this = this;
      var exps = _this.Emotion;
        for (var i = 0; i < exps.length; i++) {
            con = con.replace(exps[i].reg, '<img class="faceImg1" src="' + exps[i].src + '" style="vertical-align: middle" alt=""  />');
        }
      console.log(con, 333);
      return con;
    },
    sendMsg (value,event) {
      let vm = this;
      //console.log(this.msgValue,event)
      // 直接发送消息
      if(event.keyCode === 13 && !event.ctrlKey) {
          event.preventDefault();
          this.$store.dispatch({
            type: 'sendMessage',
            content: this.msgValue.replace(/\n/g,'<br>'),
            contentType: Constants.TEXT_TYPE,
            visitorMd5Code: sessionStorage.md5
          })
          vm.msgValue = '';
      }else if(event.keyCode === 13 && event.ctrlKey) {
        console.log(document.getElementsByTagName('textarea')[0],"document.getElementsByTagName('textarea')[0]")
        document.getElementsByTagName('textarea')[0].value=document.getElementsByTagName('textarea')[0].value+'\r';
        console.log(this.msgValue,"this.msgValue")
        return false;
        // this.$store.dispatch({
        //     type: 'sendMessage',
        //     content: this.msgValue.replace(/\n/g,'<br>'),
        //     contentType: Constants.TEXT_TYPE,
        //     visitorMd5Code: sessionStorage.md5
        //   })
      }


    },
    sendMsg2 (value, event) {
       this.$store.dispatch({
            type: 'sendMessage',
            content: this.msgValue.replace(/\n/g,'<br>'),
            contentType: Constants.TEXT_TYPE,
            visitorMd5Code: sessionStorage.md5
          })
           this.msgValue = '';
    },
    showsatisfySetting () {
      this.$store.commit("setShowSatisfySettingFlag", true)
      this.$store.dispatch({
        type: 'getSatisfySettting',
        visitorMd5Code: sessionStorage.md5
      })
    },
    msgChange (newMsg) {
        let vm = this;
        vm.$store.dispatch({
          type: 'sendTransientMessage',
          contentType: Constants.TEXT_TYPE,
          content: '对方正在输入: ' + vm.replaceFace(newMsg),
          visitorMd5Code: sessionStorage.md5
        })
    },
    sendImgMsg (event) {
      var vm = this;
      // console.log(event)
      var files = event.target.files;
      //console.log(files,"files")
      if(files.length >3) {
        Message({
          type:'warning',
          message:'最多上传三个图片或视频'
        })
      }
      for (var index= 0; index<files.length; index++){
        const ctm = new Date().getTime()
          const signId = '' + ctm + index
          this.$store.dispatch({
            type: 'sendImgMsg',
            file: files[index],
            visitorMd5Code: sessionStorage.md5,
            signId,
            status: 'load',
            ctm,
            callback:()=>{
              console.log('-----callback')
              // 清空image选择框的值
              vm.$refs.imgfile.value = "";
            }
          })
      }
    },
    scorllTop (event) {
       var event = event || window.event
       //console.log(event.target.scrollTop,"event")
       //console.log(this.$store.state.im)
       if(event.target.scrollTop ===0)
        this.getHistorySession ()
    },
    getHistorySession () {
      var vm = this;
      let seq = this.$store.state.im.messageList[0].seq
      let sessionId = this.$store.state.im.messageList[0].sessionId
      let visitorMd5Code = sessionStorage.md5
      console.log(sessionId,seq,"ss",this.$store.state.im.messageList)
      if(sessionId &&  seq){
        this.$store.dispatch({
          type:'getLastMessage',
          visitorMd5Code: sessionStorage.md5,
          router: vm.$router,
          offsetSeq: seq,
          sessionId,
        })
      }
    //   axios.post(imUrl + '/confirmEvent/'+msgId+'?visitorMd5Code='+visitorMd5Code,obj).then((response) => {
    //         console.log(response, "向后台发送自动消息");
    //     }, (err) => {
    //         console.log(err)
    //     })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .headerImg {
    width: 49px;
    height: 49px;
    border-radius: 100%;
  }
.imgMask{
  position: absolute;
  top: 0;
  bottom:0;
  left: 0;
  right: 0;
  z-index: 1000;
  background:rgba(0,0,0,.5);
}
.imgMask img{
  width: 80%;
  position: absolute;
  top:50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
}
.faceImg1{
  vertical-align: middle;
}
.imSession{
  position: relative;
}
.a-upload {

    height: 25px;
    width: 25px;
    line-height: 10px;
    position: absolute;
    left: 36px;
    top: -3px;
    cursor: pointer;
    color: #888;
    /*background: #fafafa;*/
    /*border: 1px solid #ddd;*/
    border-radius: 4px;
    overflow: hidden;
    display: inline-block;
    display: inline;
    zoom: 1
}
.a-upload-left{
  left: -3px !important;
}
.a-upload input{
    width: 25px;
    height: 25px;
    opacity: 0;
    font-size: 0;
    filter: alpha(opacity=0);
    /*cursor: pointer*/
}
.imSession .sessionContent{
  /*height: 440px;*/
  width: 100%;
  height: 415px;
  padding-top: 28px;
  overflow-y: auto;
  overflow-x: hidden;
  /* box-sizing: border-box; */
}
.imgP {
  max-width: 160px;
  margin-top: 10px;
  border-radius: 5px;
}
.chat-mine {
    display: flex;
    margin: 0 20px;
}
.chat-mine i {
  position: absolute;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  top: 12px;
}
.wraper {
  max-width: 90%;
}
.userNickName{
  margin-left: 20px;
  color: #595959;
}
.chatContent {
  position: relative;
  /*max-width: 80%;*/
  margin-bottom: 24px;
}
.chatContent .chat-text {
  line-height: 40px;
  border: 1px solid #ccc;
  text-align: left;
  background: #fff;
  border-radius: 4px;
  margin-left: 20px;
  padding: 0 10px;
  word-break:break-all;
  word-wrap: break-word;

}
.chatContent .chat-text.nobg {
  background: none;
  border: none;
  padding: 0;
}
  .chatContent .chat-text1 {
    /*line-height: 40px;*/
    border: 1px solid #ccc;
    text-align: left;
    background: #fff;
    border-radius: 4px;
    margin-left: 20px;
    padding: 0 10px;
    word-break:break-all;
    word-wrap: break-word;

  }
.chatContent:after{
  content: '';
  position: absolute;
  left: 15px;
  top: 7px;
  width: 10px;
  height: 10px;
  background: #ffffff;
  transform:  rotate(45deg);
  -webkit-transform:  rotate(45deg);
  -moz-transform:  rotate(45deg);
  -o-transform:  rotate(45deg);
  -ms-transform:  rotate(45deg);
  border-style: none none solid solid;
  border-color: #fff #cccccc #cccccc;
  border-width: 1px;
}
.chatContent.nobg:after{
  display: none;
}
/*.chatContent .order{
  /*border: 1px solid #cccccc;
}*/
.chat-mine2 {
  display: flex;
  justify-content: flex-end;
  margin: 0 20px;


}
.chat-mine2 i {
  position: absolute;
  width: 0;
  height: 0;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  top: 12px;
}
.chatContent2 {
  position: relative;
  /*max-width: 80%;*/
   margin-bottom: 24px;
}
.chatContent2 .chat-text2 {
  line-height: 40px;
  border: 1px solid #ccc;
  text-align: left;
  background: #36c6d3;
  border-radius: 4px;
  margin-right: 20px;
  padding: 0 10px;
  color: #ffffff;
  word-break:break-all;
  word-wrap: break-word;
}
.chatContent2 .chat-text2.nobg {
  background:none;
  border: none;
  padding: 0;
}
.chatContent2 .chat-text2.imgEmpty {
  min-width: 150px;
  min-height: 150px;
  text-align: center;
  line-height: 150px;
}
.chatContent2:after{
  content: '';
  position: absolute;
  right: 15px;
  top: 7px;
  width: 10px;
  height: 10px;
  background: #36c6d3;
  transform:  rotate(45deg);
  -webkit-transform:  rotate(45deg);
  -moz-transform:  rotate(45deg);
  -o-transform:  rotate(45deg);
  -ms-transform:  rotate(45deg);
  border-style: solid solid solid solid;
  border-color: #36c6d3 #36c6d3 #36c6d3;
  border-width: 1px;
}
.chatContent2.nobg:after {
  display: none;
}
.imSession .sessionContent .emotions {
  position: absolute;
  bottom: 135px;
  left: 10px;
  width: 290px;
  height: 90px;
  background: #f8f8f8;
  z-index: 1000;
  border-radius: 3px;
  /*background: pink;*/

  border: 1px solid #cccccc;
  padding: 5px;
  box-shadow: 0 0 15px #999;
}
.imSession .sessionContent .imgwraper{
  border: 1px solid #cccccc;

}
.imSession .sessionContent .triangle {
  position: relative;
  width: 15px;
  height: 15px;
  background: #f8f8f8 ;
  display: inline-block;
  z-index: 100;
  transform: translate(0, -5px) rotate(45deg);
  -webkit-transform: translate(0, -5px) rotate(45deg);
  -moz-transform: translate(0, -5px) rotate(45deg);
  -o-transform: translate(0, -5px) rotate(45deg);
  -ms-transform: translate(0, -5px) rotate(45deg);
}
.imSession .sessionContent .emotions .emotion {

  display: inline-block;
  /*margin: 10px;*/
  background: #ffffff;
  cursor: pointer;
}
.imSession .sessionContent .emotions .emotion span {
  display: inline-block;
  margin: 0 5px;
  width: 26px;
  height: 27px;
  padding-top: 3px;
}
.imSession .sessionInput {
  /*position: relative;*/
  /*background: pink;*/
  height: 130px;
 border: 1px solid #ccc;
}
.imSession .sessionInput .img_icon_box {
  /*position: absolute;*/
  position: relative;
  margin: 10px 0 5px 15px;
}
.imSession .sessionInput .img_icon_btn {
  margin-right: 15px;
  cursor: pointer;
}
.imSession .sessionInput .img_icon_btn.hidden {
  display: none;
}
.imSession .sessionInput .input_content {
  font-size: 18px;
  padding-left: 15px;
  background: #f8f8f8;
  border: none;
  outline: none;
}
.imSession .sessionInput .input_content:focus {
  appearance: none;
}
.imSession .sessionInput .sendMsg {
    display: block;
    position: absolute;
    bottom: 5px;
    right: 20px;
    width: 70px;
    height: 30px;
    background: #009688;
    color: #f4f9f8;
    border-radius: 6px;
    margin: 40px auto  0;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    text-decoration: none;
}
.imSession .sessionInput .CtrEnt {
  position: absolute;
  bottom: 10px;
  right: 100px;
  color:#ccc;
}
.endclass{
  text-align: center;
  line-height: 120px;
  font-size: 14px;
}
.createtime{
  clear: both;
  width: 100%;
  height: 14px;
  text-align: center;
  font-size: 12px;
  color: #666;
}
.video-container {
  max-width: 128px;
  max-height: 240px;
  line-height: 0;
  padding-left: 0!important;
  // margin-left: 15px;
  position: relative;
  overflow: hidden;
  img {
    border-radius: 5px;
  }
  .player-icon {
    font-size: 28px;
    color: #fff;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-table;
  }
  .masking-out {
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 10;
  }
}
.video-dialog {
  width: 640px;
  height: 620px;
  overflow: hidden;
  margin: -310px 0 0 -320px;
  background: rgba(0, 0, 0, 0.12);
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 50%;
  left: 50%;
  z-index: 3000;
.video-content {
  max-height: 90%;
}
.video-close {
  position: absolute;
  top: 20px;
  right: 20px;
  z-index: 10;
  cursor: pointer;
  i {
    font-size: 35px;
    color: #fff;
  }
}
}
.img-box {
  position: relative;
}
.imSession .chat-mine2 .loading-icon {
  width: auto;
  height: auto;
  font-size: 30px;
  margin: -15px 0 0 -15px;
  position: absolute;
  left: 50%;
  top: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/im/imSession.vue?76be3352